import React from 'react';
import {
  useIbkrCommModeQuery,
  useSetIbkrCommModeMutation,
} from '../../features/diagnostics/api/diagnostics.queries';

const MODE_LABELS = {
  oauth: 'OAuth v2 (Web API)',
  socket: 'Socket v1 (Gateway/TWS)',
};

export default function IbkrCommModeToggle() {
  const { data, isLoading } = useIbkrCommModeQuery();
  const setMode = useSetIbkrCommModeMutation();

  const mode = data?.mode || 'oauth';
  const source = data?.source || 'env';
  const isPending = setMode.isPending;

  return (
    <div className="ibkr-mode-toggle card card-compact">
      <div className="ibkr-mode-toggle__row">
        <span className="ibkr-mode-toggle__label">IBKR Mode</span>
        <span className="subtle">
          {source === 'runtime' ? 'runtime override' : 'env default'}
        </span>
      </div>
      <select
        value={mode}
        disabled={isLoading || isPending}
        onChange={(event) => setMode.mutate(event.target.value)}
      >
        <option value="oauth">{MODE_LABELS.oauth}</option>
        <option value="socket">{MODE_LABELS.socket}</option>
      </select>
    </div>
  );
}
